var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-2" }, [
    _vm.shouldDisplayPXFMention && _vm.pxfLegalMentionsText
      ? _c("div", [
          _c("span", {
            staticClass: "font-weight-bold small",
            domProps: { innerHTML: _vm._s(_vm.pxfLegalMentionsText) },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("p", { staticClass: "small" }, [
      _c("sup", { staticClass: "d-table-cell" }, [_vm._v("1 ")]),
      _vm._v(" "),
      _c("span", { staticClass: "d-table-cell" }, [
        _vm._v(_vm._s(_vm.dasDescription)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }